import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import PrintTicketPostAction from '../post-action/printTicketPostAction';

export default class PrintTicketAction extends AttendeeAction {
    static NAME = 'print_ticket';
    static POST_ACTION_COMPONENT = PrintTicketPostAction;
    static CAPACITIES = ['PyvarCapacity.ADMIN', 'PyvarCapacity.PRINTER'];
    // static POST_ACTION_TOAST = response => {
    //     if (response['initial_count'] === 1) {
    //         return null;
    //     }
    //     return (
    //         <Trans
    //             i18nKey="ticket.manager.attendees.action.print_ticket.toast.custom_success_plural"
    //             values={{ initial_count: response['initial_count'] }}
    //         />
    //     );
    // };

    // TODO ADRIEN : Attendee valid + non rembourser
    static condition(attendee) {
        return ['valid'].includes(attendee.order.status) && !attendee.removed;
    }

    static is_available({ feature_flags, permissions, organization }) {
        return !feature_flags.includes('EO_APPR') && Boolean(permissions.hasCapacities(['PyvarCapacity.ADMIN', 'PyvarCapacity.PRINTER'], organization.id));
    }

    get is_direct() {
        return true;
    }

    // global
    get needs_confirm() {
        return false;
    }

    // simple
    get needs_selection() {
        return false;
    }

    run({ data_to_print = {}, event, organization, printer_client }) {
        // return printer_client.print(data_to_print)
        return Promise.resolve(true);
    }

    runPostAction(form) {
        // if (form.orders) {
        //     return Order.perform_action(this.constructor.NAME, { order: form.orders }, { organization: this.organization, event: this.event });
        // }

        return Attendee.perform_action(this.constructor.NAME, form, { organization: this.organization });
    }

    get post_action() {
        return true;
    }

    onActionDone() {
        this.onClose();
    }
}
